<template>
    <div class="row">
        <br /><br /><br />
        <div
            class="col-sm-12 col-md-12"
            v-if="form.combined_free_shipping_amount != null"
        >
            <h3 class="mb-0">Free Shipping Settings</h3>
            <div class="row mt-3"></div>

            <div class="row mt-2">
                <div class="col-md-3 pb-2">
                    <div class="form-group">
                        <label class="text-muted">Suppressors </label>
                        <div class="input-group">
                            <input
                                type="number"
                                class="form-control"
                                autocomplete="off"
                                v-model="form.suppressor_free_shipping_amount"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-3 pb-2">
                    <div class="form-group">
                        <label class="text-muted">Accessories </label>
                        <div class="input-group">
                            <input
                                type="number"
                                class="form-control"
                                autocomplete="off"
                                v-model="form.accessory_free_shipping_amount"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-md-3 pb-2">
                    <div class="form-group">
                        <label class="text-muted">Combined </label>
                        <div class="input-group">
                            <input
                                type="number"
                                class="form-control"
                                autocomplete="off"
                                v-model="form.combined_free_shipping_amount"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-5 submit-order-button">
                <div class="col-md-4">
                    <button
                        @click="saveSettings"
                        type="submit"
                        class="btn btn-outline-danger text-uppercase float-end w-100"
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

export default {
    props: [],
    emits: [],
    components: {},
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });

        let pricelistsTable = computed(function () {
            return store.state.pricelistsTable;
        });

        onMounted(() => {});

        return {
            store,
            user,
            pricelistsTable,
        };
    },
    data() {
        return {
            form: {
                accessory_free_shipping_amount: null,
                combined_free_shipping_amount: null,
                suppressor_free_shipping_amount: null,
            },
        };
    },
    computed: {},
    mounted() {
        this.getSettings();
    },
    methods: {
        getSettings() {
            axios.get("/api/free-shipping-settings").then((res) => {
                let data = res.data;
                this.form.accessory_free_shipping_amount =
                    data.accessory_free_shipping_amount;
                this.form.combined_free_shipping_amount =
                    data.combined_free_shipping_amount;
                this.form.suppressor_free_shipping_amount =
                    data.suppressor_free_shipping_amount;
            });
        },
        saveSettings() {
            window.emitter.emit("changeLoaderStatus", true);
            axios
                .post("/api/free-shipping-settings", this.form)
                .then((res) => {})
                .finally(() => {
                    window.emitter.emit("alertSuccess", {
                        message: "Settings Saved!",
                    });
                    window.emitter.emit("changeLoaderStatus", false);
                });
        },
    },
};
</script>
